<template>
  <dialog
    :id="modalId"
    class="modal z-[9999]"
    :class="{ 'modal-open': isOpen }"
  >
    <div class="modal-box w-11/12 max-w-lg rounded-[20px] bg-white text-black p-0 shadow-2xl overflow-hidden flex flex-col font-['Raleway']">
      <!-- Header -->
      <div class="px-7 pt-6 pb-4 flex items-start justify-between border-b border-gray-100">
        <div>
          <div class="flex items-center gap-2">
            <span class="inline-flex items-center justify-center w-6 h-6 rounded-full bg-amber-100 text-amber-700 text-xs font-bold shrink-0">⚠️</span>
            <h3 class="font-bold text-[18px] text-[#043f42] m-0">
              Unmapped Signatories Remaining
            </h3>
          </div>
          <p class="text-[13px] text-gray-500 m-0 mt-1.5 leading-relaxed">
            You have configured signatories who currently have no signing fields or data inputs mapped on this document.
          </p>
        </div>
        <button
          type="button"
          class="text-gray-400 hover:text-gray-700 text-2xl font-light leading-none border-none bg-transparent cursor-pointer p-1"
          @click="$emit('close')"
        >
          &times;
        </button>
      </div>

      <!-- Count & Progress Meter -->
      <div class="px-7 py-3 bg-[#f8fafc] border-b border-gray-100 flex items-center justify-between">
        <div class="text-[13px] font-semibold text-[#043f42]">
          Mapped: <span class="text-[#01d680] font-bold">{{ mappedCount }}</span> of {{ totalCount }} Signatories
        </div>
        <span class="text-[11px] font-semibold text-amber-700 bg-amber-50 border border-amber-200 px-2.5 py-0.5 rounded-full">
          {{ unmappedCount }} Left to Complete
        </span>
      </div>

      <!-- Scrollable List of Unmapped Signatories -->
      <div class="px-7 py-4 overflow-y-auto max-h-[35vh] flex flex-col gap-2">
        <div
          v-for="(sub, idx) in unmappedSubmitters"
          :key="sub.uuid || idx"
          class="flex items-center justify-between p-3 rounded-[12px] bg-[#fbfdfc] border border-gray-200 hover:border-gray-300 transition-colors"
        >
          <div class="flex items-center gap-3 min-w-0">
            <div class="w-7 h-7 rounded-full bg-[#043f42]/10 text-[#043f42] font-semibold text-xs flex items-center justify-center shrink-0">
              {{ sub.order != null ? sub.order + 1 : idx + 1 }}
            </div>
            <div class="min-w-0">
              <div class="text-[13px] font-semibold text-[#043f42] truncate">
                {{ sub.name || 'Unnamed Signatory' }}
              </div>
              <div class="text-[11px] text-gray-500 truncate">
                {{ sub.email || 'No email attached' }}
              </div>
            </div>
          </div>
          <span class="text-[11px] font-medium text-amber-700 bg-amber-50 border border-amber-200 px-2 py-0.5 rounded-full shrink-0">
            0 Fields Mapped
          </span>
        </div>
      </div>

      <!-- Footer Actions -->
      <div class="px-7 py-4 bg-gray-50 border-t border-gray-100 flex flex-col sm:flex-row items-center justify-between gap-3">
        <button
          type="button"
          class="w-full sm:w-auto text-[13px] font-medium text-gray-500 hover:text-gray-800 bg-transparent border-none cursor-pointer py-2 px-1 text-center"
          @click="$emit('close')"
        >
          Dismiss
        </button>
        <div class="flex items-center gap-2.5 w-full sm:w-auto justify-end">
          <button
            type="button"
            class="w-full sm:w-auto px-4 py-2 text-[13px] font-semibold text-[#043f42] bg-white border border-[#043f42]/30 hover:border-[#043f42] hover:bg-[#043f42]/5 rounded-full cursor-pointer transition-all"
            @click="$emit('remove-unmapped')"
          >
            Remove Unmapped & Save
          </button>
          <button
            type="button"
            class="w-full sm:w-auto px-5 py-2 text-[13px] font-semibold text-black bg-[#01d680] hover:bg-[#00c576] rounded-full cursor-pointer border-none shadow-xs transition-all flex items-center justify-center gap-1.5"
            @click="$emit('continue-mapping', unmappedSubmitters[0])"
          >
            <span>Continue Mapping</span>
            <span class="text-xs">&rarr;</span>
          </button>
        </div>
      </div>
    </div>
  </dialog>
</template>

<script>
export default {
  name: 'UnmappedSignatoriesModal',
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    submitters: {
      type: Array,
      default: () => []
    },
    fields: {
      type: Array,
      default: () => []
    },
    modalId: {
      type: String,
      default: 'unmapped_signatories_modal'
    }
  },
  emits: ['close', 'continue-mapping', 'remove-unmapped'],
  computed: {
    unmappedSubmitters () {
      return this.submitters.filter(
        (sub) => !this.fields.some((f) => f.submitter_uuid === sub.uuid)
      )
    },
    mappedSubmitters () {
      return this.submitters.filter(
        (sub) => this.fields.some((f) => f.submitter_uuid === sub.uuid)
      )
    },
    mappedCount () {
      return this.mappedSubmitters.length
    },
    unmappedCount () {
      return this.unmappedSubmitters.length
    },
    totalCount () {
      return this.submitters.length
    }
  }
}
</script>
